import PropTypes from 'prop-types'
import EtapForm from '../parts/EtapForm.jsx'

export const EtapPrzygotowania = (props) => {
    return <EtapForm wiz={props.wiz} etapKey="przygotowania" />
}

EtapPrzygotowania.propTypes = {
    wiz: PropTypes.any,
}